import Vue from 'vue';
import grants from '@/grants';
import { mergeDeep } from '@/plugins/mergeDeep';
import { getMe } from '@/api/users';
import { getTeam } from '@/api/panel';

export default {
  namespaced: true,
  state: () => ({
    logStatus: 'init',
    team: null,
    user: null,
    grants
  }),

  getters: {
    getLogStatus: (state) => state.logStatus,
    getTeam: (state) => state.team || {},
    getUser: (state) => state.user || {},
    getGrants: (state) => state.grants,
    getGrantValue: (state) => (grant) => {
      const grantSplit = grant.split('.');
      const name = grantSplit[0];
      const value = grantSplit[1];

      return state.grants[name][value];
    }
  },

  mutations: {
    setLogStatus(state, status) {
      state.logStatus = status;
    },
    setUser(state, user) {
      Vue.set(state, 'user', user);
    },
    setTeam(state, team) {
      Vue.set(state, 'team', team);
    },
    setGrants(state, userGrants) {
      const mergedGrants = mergeDeep(grants, userGrants);
      Vue.set(state, 'grants', mergedGrants);
    }
  },

  actions: {
    async CHECK_LOGIN_STATUS({ dispatch, commit }) {
      // console.log('CHECK_LOGIN_STATUS');
      const at = window.localStorage.getItem('at');
      if (at) {
        commit('setLogStatus', 'login');
        const lang = localStorage.getItem('language')
          ? localStorage.getItem('language').toLowerCase()
          : 'tw';
        const User = await getMe({ lang: lang });
        if (!User.error) {
          commit('setUser', User);
          return true;
        } else {
          dispatch('DO_LOGOUT');
          return false;
        }
      }
      return false;
    },
    async FETCH_TEAMS({ commit }) {
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';
      const Team = await getTeam({ lang: lang });
      commit('setTeam', Team);
    },
    DO_LOGOUT({ commit }) {
      window.localStorage.removeItem('at');
      window.localStorage.removeItem('rt');
      commit('setLogStatus', 'logout');
    },
    SET_ACCESS_TOKENS(store, { at, rt }) {
      window.localStorage.setItem('at', at);
      window.localStorage.setItem('rt', rt);
    }
  }
};
